
const reasons = [
  {
    icon: 'ri-team-line',
    title: 'Deneyimli Ekip',
    description: 'Almanya\'da eğitim ve iş hayatında yıllarca deneyim sahibi profesyonel danışmanlarımızla yanınızdayız.',
  },
  {
    icon: 'ri-map-pin-line',
    title: 'Berlin Merkezli',
    description: 'Almanya\'nın başkenti Berlin\'de ofisimizle yerinde destek sağlıyoruz.',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Kesintisiz Destek',
    description: 'Başvuru sürecinden Almanya\'ya yerleşene kadar her aşamada yanınızdayız.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Güvenilir Hizmet',
    description: 'Yüzlerce öğrencinin başarı hikayesiyle kanıtlanmış güvenilir danışmanlık.',
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Eksiksiz Belge Hazırlığı',
    description: 'Vize ve başvuru için gerekli tüm belgeleri eksiksiz ve doğru şekilde hazırlıyoruz.',
  },
  {
    icon: 'ri-price-tag-3-line',
    title: 'Uygun Fiyat',
    description: 'Kaliteli hizmeti en uygun fiyatlarla sunarak bütçenize uygun çözümler üretiyoruz.',
  },
];

export default function WhyUs() {
  return (
    <section id="hakkimizda" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#FFCE00]/10 rounded-full mb-6">
              <i className="ri-star-line text-[#DD0000]"></i>
              <span className="text-[#1a1a1a] text-sm font-medium">Neden Rota Berlin?</span>
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-[#1a1a1a] mb-6 leading-tight">
              Almanya'da Eğitim İçin
              <span className="text-[#DD0000]"> En Doğru Adres</span>
            </h2>

            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Rota Berlin olarak, Türkiye'den Almanya'ya eğitim almak isteyen öğrencilere kapsamlı danışmanlık hizmeti sunuyoruz. Berlin merkezli ofisimizle, başvuru sürecinden Almanya'ya yerleşene kadar her aşamada yanınızdayız.
            </p>

            <div className="space-y-4">
              {reasons.map((reason, index) => (
                <div
                  key={index}
                  className="flex items-start gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors group cursor-pointer"
                >
                  <div className="w-12 h-12 rounded-lg bg-[#DD0000] flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                    <i className={`${reason.icon} text-xl text-white`}></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-[#1a1a1a] mb-1 group-hover:text-[#DD0000] transition-colors">
                      {reason.title}
                    </h3>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {reason.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-8">
              <a
                href="#iletisim"
                className="inline-flex items-center gap-2 px-8 py-4 bg-[#DD0000] text-white text-lg font-semibold rounded-lg hover:bg-[#bb0000] hover:shadow-xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer"
              >
                <span>Hemen Başlayın</span>
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/08523dee6044b53f1a1262ce77a03bf6.jpg"
                alt="Rota Berlin Danışmanlık"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
            </div>

            {/* Floating Card */}
            <div className="absolute -bottom-8 -left-8 bg-white rounded-2xl p-6 shadow-2xl border border-gray-100 max-w-xs">
              <div className="flex items-center gap-4 mb-3">
                <div className="w-12 h-12 rounded-full bg-[#FFCE00] flex items-center justify-center">
                  <i className="ri-trophy-line text-2xl text-[#1a1a1a]"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-[#1a1a1a]">500+</div>
                  <div className="text-sm text-gray-600">Başarılı Öğrenci</div>
                </div>
              </div>
              <p className="text-xs text-gray-500">
                Almanya'da eğitim hayallerini gerçekleştiren öğrencilerimiz
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
